module.exports = __webpack_public_path__ + "static/media/Nasu-Regular.cdf0f7f9.ttf";